import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useCreateProspectMutation } from 'services/api/prospects.api';

const WhatsAppIntegrationSuccess = () => {
  // https://app.relif.com/WhatsAppIntegrationSuccess?client=xxxxCL&channels=[yyyyCH]&revoked=[zzzzCH]&state=someStatePassedThrough
  const [createProspect, { isSuccess }] = useCreateProspectMutation();
  // Extract query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const client = urlParams.get('client');
  const channels = urlParams.get('channels');
  const revoked = urlParams.get('revoked');
  const state = urlParams.get('state');

  useEffect(() => {
    createProspect({
      email: `${client || ''}_360Dialog@zeller.ai`,
      phone: '',
      rut: '',
      reason: `360 Integration with Relif: client=${client}, channels=${channels}, revoked=${revoked}, state=${state}`,
    }).catch((error) => {
      console.error('Error creating prospect', error);
    });
  }, []);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: 480,
          width: '100%',
          textAlign: 'center',
          bgcolor: 'background.paper',
          borderRadius: 3,
          boxShadow: 3,
          p: { xs: 4, md: 6 },
        }}
      >
        <Box sx={{ mb: 4, display: 'flex', justifyContent: 'center' }}>
          <img src="/logo.webp" alt="Relif" style={{ maxWidth: 220, width: '100%', height: 'auto' }} />
        </Box>
        <Typography variant="h4" sx={{ fontWeight: 600 }}>
          Integración de WhatsApp exitosa
        </Typography>
        {isSuccess && (
          <Typography
            sx={{
              color: 'text.secondary',
              mt: 2,
            }}
          >
            El equipo de Relif ha sido notificado.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default WhatsAppIntegrationSuccess;
